
import React, {useEffect} from 'react';
import { Grid, Typography, withStyles } from '@material-ui/core';
import { useSelector, useDispatch } from "react-redux";
import { getProfile, changePassword } from '../../store/profile';


function Profile(props) {
  const dispatch = useDispatch();
  const {isMobile} = props;
  const profile = useSelector(state => state.entities.profile.profile);
  const loading = useSelector(state => state.entities.profile.loading);

  useEffect(() => {
    dispatch(getProfile());
  }, []);

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography>Name: {profile.first_name} {profile.last_name}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography>Airline: {profile.airline_id}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography>Role: {profile.user_type}</Typography>
      </Grid>
    </Grid>
  );
}

export default Profile